import React, { useId } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import FormattedDate from '../../utils/DateFormat';

const tooltipStyle = {
    maxWidth: '90vw',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    zIndex: 9999,
    fontSize: '14px',
};

const ConteoCheck = ({ show, empleado, fecha, tooltipId }) => {
    const autoId = useId();
    const id = tooltipId || autoId;

    if (show) {
        return (
            <>
                <span
                    className="inline-flex items-center font-bold px-1 py-1 rounded-full"
                    data-tooltip-id={id}
                    data-tooltip-content={`Conteo realizado por ${empleado || 'Desconocido'} el ${FormattedDate(fecha)}`}
                >
                    <FaCheckCircle className="h-6 w-6 text-green-600 hover:text-green-800" />
                </span>
                <Tooltip id={id} place="top" style={tooltipStyle} />
            </>
        );
    }

    return (
        <>
            <span
                className="inline-flex items-center font-bold px-1 py-1 rounded-full"
                data-tooltip-id={id}
                data-tooltip-content="Pendiente por Contar"
            >
                <FaTimesCircle className="h-6 w-6 text-red-600 hover:text-red-800" />
            </span>
            <Tooltip id={id} place="top" style={tooltipStyle} />
        </>
    );
};

export default ConteoCheck;
